import { lazy } from 'react';

const InterestedDialog = lazy(() => import('@/attendance/dialogs/InterestedDialog'));
const AttendanceSetupCompleteDialog = lazy(() => import('@/attendance/dialogs/AttendanceSetupCompleteDialog'));

export const INTERESTED_DIALOG = 'INTERESTED_DIALOG';
export const ATTENDANCE_SETUP_COMPLETE_DIALOG = 'ATTENDANCE_SETUP_COMPLETE_DIALOG';

const dialogs = {
  [INTERESTED_DIALOG]: InterestedDialog,
  [ATTENDANCE_SETUP_COMPLETE_DIALOG]: AttendanceSetupCompleteDialog,
  // ...
};

export default dialogs;
